/* Copyright (c) 2020-present CloudIO Inc */

import { useStateXWritableSelector } from '@cloudio-saas/statex';
import React, { memo } from 'react';
import { AnyManager, AnyItem } from 'componentregistry';
import { itemExpandedSelector } from 'layout/Sidebar/itemExpandedSelector';
import Icon from 'icons/Icon';

interface Props {
  appUid: string;
  pageId: string;
  treename: string;
  mgr: AnyManager;
  item: AnyItem;
  className: string;
  dragging?: boolean;
}

function TreeNodeExpandCollapseIcon({
  appUid,
  pageId,
  treename,
  mgr,
  item,
  className,
}: Props): React.ReactElement | null {
  const [expanded, setExpanded] = useStateXWritableSelector(
    itemExpandedSelector,
    {
      params: { appUid, pageId, itemId: item.itemId, treename },
    },
  );
  let icon = null;
  if (item.children?.length) {
    icon = expanded ? (
      <Icon
        data-testid="tree-node-collapse"
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          setExpanded(false);
        }}
        iconName="minus-circle"
        aria-label={`Collapse ${mgr.name}`}
      />
    ) : (
      <Icon
        data-testid="tree-node-expand"
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          setExpanded(true);
        }}
        iconName="plus-circle"
        aria-label={`Expand ${mgr.name}`}
      />
    );
  } else if (mgr.canHaveChildren()) {
    icon = <Icon iconName="circle" className={className} />;
  }

  return icon;
}

export default memo(TreeNodeExpandCollapseIcon);
